import { Alert, Stack, Typography } from '@mui/material';
import React from 'react';
import AwsUploadCommandGenerator from './AwsUploadCommandGenerator';
import { OperatingSystem } from './cliInstructionTypes';
import { CopyableBlock } from './CopyableCliBlock';

const S3_URI_PATTERN = /^s3:\/\/[^/\s]+(?:\/.*)?$/;

const isValidS3Uri = (value: string) => S3_URI_PATTERN.test(value);

const GrantBasedAwsUploadCommandGenerator = ({
  awsProfileName,
  operatingSystem,
  slideDirectory,
}: {
  awsProfileName: string;
  operatingSystem?: OperatingSystem;
  slideDirectory: string;
}) => {
  return (
    <Stack spacing={1.5}>
      {!slideDirectory ? (
        <>
          <Typography variant="body2" color="text.secondary">
            Enter the source S3 file or folder, then generate a complete AWS CLI command for this study.
          </Typography>
          <Alert severity="error">
            Upload destination could not be loaded from the study. Please contact Nucleai support.
          </Alert>
        </>
      ) : (
        <AwsUploadCommandGenerator
          copyableCommandBlock={(command) => (
            <CopyableBlock text={command} copyButtonAriaLabel="Copy AWS CLI upload command" />
          )}
          destination={slideDirectory}
          operatingSystem={operatingSystem}
          sourceType="s3"
          invalidSourceText="Use an S3 path in the form s3://bucket-name/optional/path-to-file-or-folder."
          isSourceValid={isValidS3Uri}
          sourceLabels={{ recursive: 'Source folder or S3 URI', singleFile: 'Source file or S3 URI' }}
          uploadOptions={[
            ...(awsProfileName ? [`--profile ${awsProfileName}`] : []),
            '--acl bucket-owner-full-control',
            '--sse AES256',
          ]}
        />
      )}
    </Stack>
  );
};

export default GrantBasedAwsUploadCommandGenerator;
